import { OptionAttribute } from '@models/core/OptionAttribute';
import Slot from '@models/Slot';
import { convertHexToRGBA } from 'src/helper/ColorHelper';
import Yard from 'src/models/Yard';
import { sessionBloc } from '../bloc/SessionBloc';
import ArrayModelAttribute from './core/ArrayModelAttribute';
import Attribute from './core/Attribute';
import AttributesCollection from './core/AttributeCollection';
import ModelAttribute from './core/ModelAttribute';
import Model from './Model';
import Option from './Option';
import Report from './Report';
import YardShare from './YardShare';
import ArrayAttribute from './core/ArrayAttribute';
import DateAttribute from "@models/core/DateAttribute";
import Sector from './Sector';
import Vehicule from './Vehicule';
import UserSectorArea from './UserSectorArea';
import UserDailyPlanning from './UserDailyPlanning';


export default class User extends Model {

  public firstname: string
  public lastname: string
  public email: string
  public phone: string
  public type: string
  public password: string;
  public currentYard: Yard;
  public isAdmin: boolean;
  public isManager: boolean;
  public isCustomer: boolean;
  public slotByDay: any[];
  public active: boolean;
  public role: Option;
  public senderEmail: string;
  public slots: Slot[]
  public reports: Report[]
  public absentReports: Report[]
  public yardShares: YardShare[]
  public sectorId: number
  public quartier: string
  public endRdv: string
  public startRdv: string
  public creneau1: number
  public creneau2: number
  public creneau3: number
  public creneau4: number
  public creneau5: number
  public nightSlotEnabled: boolean
  public sector: Sector
  public sectorAreas: UserSectorArea[]
  public dailyPlannings: UserDailyPlanning[]
  public vehicules: Vehicule[]
  
  static readonly modelUrl = "users";
  public modelName = "user";

  public attributes = new AttributesCollection({
    firstname: new Attribute("firstname"),
    lastname: new Attribute("lastname"),
    slotByDay: new ArrayAttribute("slotByDay"),
    email: new Attribute("email"),
    phone: new Attribute("phone"),
    active: new Attribute("active"),
    senderEmail: new Attribute("senderEmail"),
    isAdmin: new Attribute("isAdmin", {submittable: false}),
    isCustomer: new Attribute("isCustomer", {submittable: false}),
    isManager: new Attribute("isManager", {submittable: false}),
    role: new OptionAttribute("role", {optionType: "user_role"}),
    password: new Attribute("password"),
    currentYard: new ModelAttribute("currentYard", Yard, {submittable: false}),
    donePrestations: new Attribute("donePrestations", {submittable: false}),
    slots: new ArrayModelAttribute("slots", Slot, {submittable: false}),
    reports: new ArrayModelAttribute("reports", Report, {submittable: false}),
    absentReports: new ArrayModelAttribute("absentReports", Report, {submittable: false}),
    yardShares: new ArrayModelAttribute("yardShares", YardShare, {submittable: false}),
    sectorId: new Attribute("sectorId"),
    quartier: new Attribute("quartier"),
    endRdv: new DateAttribute("endRdv"),
    startRdv: new DateAttribute("startRdv"),
    creneau1: new Attribute("creneau1"),
    creneau2: new Attribute("creneau2"),
    creneau3: new Attribute("creneau3"),
    creneau4: new Attribute("creneau4"),
    creneau5: new Attribute("creneau5"),
    nightSlotEnabled: new Attribute("nightSlotEnabled"),
    sector: new ModelAttribute("sector", Sector, {submittable: false}),
    sectorAreas: new ArrayModelAttribute("sectorAreas", UserSectorArea, {submittable: false}),
    dailyPlannings: new ArrayModelAttribute("dailyPlannings", UserDailyPlanning, {submittable: false}),
    vehicules: new ArrayModelAttribute("vehicules", Vehicule, {submittable: true})
  });

  constructor(json) {
    super(json)
    this.fillAttributes(json);
  }

  public getFullName(): string {
    let str = [this.firstname, this.lastname].filter(Boolean);
    return str.join(" ");
  }

  public isMe = (): boolean => sessionBloc.state.user.id === this.id;

  public getStyle() {
    return {color: this.role.color, backgroundColor: convertHexToRGBA(this.role.color || "black", 10)}
  }

  public isShared(yardId: number) {
    return this.yardShares.find(ys => ys.yardId === yardId);
  }

  getProfitability({start, end}) {
    let total = 0;
    let isProfitable = 0;
    let reportCount = 0;
    let days = [];
    this.reports.forEach(report => {
      if (report.isBetween({start, end})) {
        total += report.profitability.amount;
        reportCount++;
        isProfitable += report.profitability.amount / report.profitability.ratio;
        if (!days.includes(report.date.getDay())) days.push(report.date.getDay())
      }
    });
    

    let divider = Math.min(reportCount, days.length);
    
    return {moy: divider ? (total / divider).toFixed(0) : "0", isProfitable: (isProfitable / divider) >= 1};
  }

}